import React from "react";
import styled, { css } from "styled-components";
import device from "../helpers/device";

export default function Speaker({
  head,
  division,
  name,
  photo,
  title,
  summary,
  size,
  ...rest
}) {
  return (
    <Wrapper size={size} {...rest}>
      <Photo size={size}>
        <img src={photo} alt={name} />
      </Photo>
      <Info size={size}>
        <div>
          {!!head && <Head>{head}</Head>}
          <Division>{division}</Division>
          <Name size={size}>{name}</Name>
          {!!title && (
            <Title>
              <span>テーマ:</span>
              <span
                className="main"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            </Title>
          )}
          {!!summary && (
            <Summary dangerouslySetInnerHTML={{ __html: summary }} />
          )}
        </div>
      </Info>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  ${({ size }) => {
    if (size === "L") {
      return css`
        text-align: center;
      `;
    }
  }}
  @media ${device.mobileL} {
    ${({ size }) => {
      if (size === "L") {
        return css`
          display: flex;
          width: 100%;
          max-width: 690px;
          margin: 0 auto;
          text-align: left;
        `;
      }
    }}
  }
`;

const Info = styled.div`
  @media ${device.mobileL} {
    ${({ size }) => {
      if (size === "L") {
        return css`
          padding-left: 40px;
          width: 390px;
          display: flex;
          align-items: center;
        `;
      }
    }}
  }
`;

const Head = styled.div`
  font-size: 14px;
  font-weight: bold;
  background: #3f271e;
  color: #fff;
  display: inline-block;
  line-height: 35px;
  padding: 0 15px;
  border-radius: 17px;
  margin: 10px 0 0 0;
  @media ${device.mobileL} {
    margin: 0 0 16px 0;
  }
`;

const Photo = styled.div`
  border-radius: 50%;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
  width: ${({ size }) => {
    if (size === "L") {
      return "200px";
    } else {
      return "120px";
    }
  }};
  height: ${({ size }) => {
    if (size === "L") {
      return "200px";
    } else {
      return "120px";
    }
  }};
  @media ${device.mobileL} {
    width: ${({ size }) => {
      if (size === "L") {
        return "300px";
      } else {
        return "150px";
      }
    }};
    height: ${({ size }) => {
      if (size === "L") {
        return "300px";
      } else {
        return "150px";
      }
    }};
  }
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;

const Division = styled.div`
  font-size: 13px;
  margin: 10px 0;
  line-height: 1;
  @media ${device.mobileL} {
    font-size: 16px;
    margin: 12px 0;
  }
`;

const Name = styled.div`
  font-weight: bold;
  line-height: 1;
  font-size: ${({ size }) => {
    if (size === "L") {
      return "20px";
    } else {
      return "16px";
    }
  }};
  @media ${device.mobileL} {
    font-size: ${({ size }) => {
      if (size === "L") {
        return "28px";
      } else {
        return "18px";
      }
    }};
  }
`;

const Title = styled.div`
  margin-top: 22px;
  font-size: 12px;
  line-height: 1;
  @media ${device.mobileL} {
    margin-top: 32px;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .main {
    font-size: 18px;
    @media ${device.mobileL} {
      font-size: 24px;
    }
  }
`;

const Summary = styled.div`
  margin: 18px auto 0 auto;
  width: 90%;
  line-height: 1.7;
  text-align: left;
  width: 76%;
  @media ${device.mobileL} {
    margin: 0 20px 0 0;
    width: 100%;
  }
`;
